import { createAction, props } from '@ngrx/store';

export const registerFlyout = createAction('[FLYOUT COMPONENT] Register', props<{ id: string }>());
export const deRegisterFlyout = createAction('[FLYOUT COMPONENT] DeRegister', props<{ id: string }>());
export const showFlyout = createAction('[FLYOUT COMPONENT] Show', props<{ id: string }>());
export const hideFlyout = createAction('[FLYOUT COMPONENT] Hide', props<{ id: string }>());
